module.exports = __webpack_public_path__ + "img/Feature.dddd9c42.jpg";